import { AfterViewInit, Component, inject, input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { db } from 'src/app/services/bd/bd';
import { ProductosDTO } from 'src/app/model/productosDTO';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';
import { environment } from 'src/environments/environment';
import { HostListener } from '@angular/core';
import { ViewportScroller } from '@angular/common';
@Component({
  selector: 'app-articulos',
  templateUrl: './articulos.component.html',
  styleUrls: ['./articulos.component.css']
})


export class ArticulosComponent  implements OnInit,AfterViewInit {
  @HostListener('window:scroll', [])
  onWindowScroll() {
   if (
     document.body.scrollTop > 100 ||
     document.documentElement.scrollTop > 100
   ) {
     document.getElementById('appear')?.classList.add('active')
   }
   else(
     document.getElementById('appear')?.classList.remove('active')
   )
 }
 title = 'WhatsApp';

  content:any = [];
  currentPage:number=0;
  totalPages:number=0;
  
  page = 0;
  size = 6;
  order = 'descripcion';
  asc = true;


  CantidadItem:string="0";
  idcategoria:number=0;
  productosdto:ProductosDTO[]=[];
  private url : string = `${environment.HOST}/api/`;
   urlServerUpload$ : string = `${environment.HOST}/api/media/`;
   tipoMedia$ : String = "/0";
   formBuscar!: FormGroup;
modoBusqueda:boolean=false;
countpedido:string="0";
nombreCuenta:String="Mi cuenta";
tieneSession:boolean=false ;
idUsrDTO:number=0;
ocultarCarrito:boolean=false;

// private api = inject(ProductoDTOService);

//   public paginator$?: Observable<ProductsPaginator>;

//   public loading$ = new BehaviorSubject(true);
//   private page$ = new BehaviorSubject(1);



   constructor(
    private productoDTOService : ProductoDTOService,
    private router:Router,
    private activatedRoute : ActivatedRoute,
    private tokenStorage: TokenStorageServiceCliente,
    private scroller: ViewportScroller,
 
  ) { 


    activatedRoute.params.subscribe( prm => {
      console.log(`El id es: ${prm['idCategoria']}`);
      this.idcategoria=prm['idCategoria'];
      
  })

  

   }
  ngAfterViewInit(): void {

  }

   

  

  ngOnInit(): void {

    this.formBuscar = new FormGroup({
      'txtBuscar' : new FormControl('', Validators.required),
    });

    this.scroller.scrollToAnchor("targetInicio");

    this.OnContarPedido();

        
    if (this.tokenStorage.getToken()!==null) {
      let json = JSON.stringify(this.tokenStorage.getUser());
      let data=JSON.parse(json.toString());
      this.idUsrDTO=data.idUsuario;
      this.nombreCuenta=data.nombre
      this.tieneSession=true ;
        }

    
        this.cargarProductoPg();
   // this.getProductosDTO3()  
    

      }


      getProductosDTO3(page:number){
        this.productoDTOService.getProductosDTO3(page,this.size,"descripcion",true , this.idcategoria).subscribe(response =>{
          console.log(response)
          return this.productosdto=response
        })
      }
      

      getProductosDTO(){
        this.productoDTOService.getProductosDTO2(  this.idcategoria).subscribe(response =>{
          console.log(response)
          return this.productosdto=response
        })
      }
    
    
    OnSelectProducto(idproducto:any){
      this.router.navigate(['/pedido', idproducto,0,0,0,0,0]);
    }


    logout(){
      this.tokenStorage.signOut();
      this.router.navigateByUrl('/inicio');
      localStorage.removeItem('shopping');
    }

    OnBuscarAll(){

      this.modoBusqueda=true ;
      this.productosdto=[];
      
      this.productoDTOService.getProductosDTOByDescripcion(0,this.formBuscar.value['txtBuscar']).subscribe(response =>{
        console.log(response);
      
          return  this.productosdto=response;
        
      });
      }



      OnBuscarPorDescripcion(){
        this.modoBusqueda=true;
        this.currentPage=0;
        this.content=[];
        this.CargarPorDescripcionPg();
      }

      CargarPorDescripcionPg(){
        

        this.productoDTOService.getProductosDTOByDescripcionPg(this.currentPage, this.size, this.order, this.asc,0,this.formBuscar.value['txtBuscar']).subscribe(
          data => {
            this.content.push(...data.content);
           // this.isFirst = data.first;
           // this.isLast = data.last;
          //  this.totalPages = new Array(data['totalPages']);
          this.totalPages=data.totalPages;
            console.log(data);
          },
          err => {
            console.log(err.error);
          }
        );

      }



      OnContarPedido(){
 
        this.ContarRegistros().then(data => {
          this.CantidadItem=data+"";
       
      
        });
       
      }
      
      async ContarRegistros() {
        return await db.detallePedidoBD.count();
        }




        cargarProductoPg() {
        
          this.productoDTOService.getProductosDTO3(this.currentPage, this.size, this.order, this.asc,this.idcategoria).subscribe(
            data => {
              this.content.push(...data.content);
             // this.isFirst = data.first;
             // this.isLast = data.last;
            //  this.totalPages = new Array(data['totalPages']);
            this.totalPages=data.totalPages;
              console.log(data.totalPages);
            },
            err => {
              console.log(err.error);
            }
          );
        }




        OnHabilitarBusqueda(){
          this.ocultarCarrito=true;
        }
        
        OnCerrarBusqueda(){
          this.ocultarCarrito=false;
        }
        



        onScroll(){

       

          if(this.modoBusqueda==false){
            this.currentPage++;
            this.cargarProductoPg();
          }else{
            this.currentPage++;
            this.CargarPorDescripcionPg();
          }

         
        }

        // onScroll(event:any){
          
        //   let scrollHeight = event.target.scrollHeight;
        //   let scrollTop = event.target.scrollTop;
        //   let clientHeight = event.target.clientHeight;

      
        //   let scrollPosition = scrollHeight - (scrollTop + clientHeight);
        //   if(scrollPosition == 0 && this.totalPages > this.currentPage){
        //     this.currentPage++;
        //     this.cargarPaises();
        //   }
        // }


        // sort(): void {
        //   this.asc = !this.asc;
        //   this.cargarPaises();
        // }
      
        // rewind(): void {
        //   if (!this.isFirst) {
        //     this.page--;
        //     this.cargarPaises();
        //   }
        // }
      
        // forward(): void {
        //   if (!this.isLast) {
        //     this.page++;
        //     this.cargarPaises();
        //   }
        // }
      
        // setPage(page: number): void {
        //   this.page = page;
        //   this.cargarPaises();
        // }
        
        // setOrder(order: string): void {
        //   this.order = order;
        //   this.cargarPaises();
        // }
      
        
        // onScroll2(): void {
        //   this.commentService
        //     .getCommentaries(++this.page)
        //     .subscribe((commentaries: Comment[]) => {
        //       this.commentaries.push(...commentaries);
        //     });
        // }


        





        
  // private loadProducts$(): Observable<ProductsPaginator> {
  //   return this.page$.pipe(
  //     tap(() => this.loading$.next(true)),
  //     switchMap((page) => this.api.getProducts$(this.idcategoria,page)),
  //     scan(this.updatePaginator, {items: [], page: 0, hasMorePages: true} as ProductsPaginator),
  //     tap(() => this.loading$.next(false)),
  //   );
  // }

  //       private updatePaginator(accumulator: ProductsPaginator, value: ProductsPaginator): ProductsPaginator {
  //         if (value.page === 1) {
  //           return value;
  //         }
      
  //         accumulator.items.push(...value.items);
  //         accumulator.page = value.page;
  //         accumulator.hasMorePages = value.hasMorePages;
      
  //         return accumulator;
  //       }
      


  //       public loadMoreProducts(paginator: ProductsPaginator) {
  //         if (!paginator.hasMorePages) {
  //           return;
  //         }
  //         this.page$.next(paginator.page + 1);
  //       }




}
